module.exports = __webpack_public_path__ + "img/icon_share_1.2a2caad7.png";